import withRichTextProps from 'viewModel/content/richText/withRichTextProps';
import RichText from 'components/Content/RichText/RichText';

export default withRichTextProps(RichText);
